import { render, staticRenderFns } from "./job-card.vue?vue&type=template&id=1fcea755&scoped=true&lang=pug"
import script from "./job-card.vue?vue&type=script&lang=coffee"
export * from "./job-card.vue?vue&type=script&lang=coffee"
import style0 from "./job-card.vue?vue&type=style&index=0&id=1fcea755&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcea755",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TextLink: require('/opt/build/repo/site/components/globals/text-link.vue').default,BtnCraft: require('/opt/build/repo/site/components/globals/btn/craft.vue').default,Squircle: require('/opt/build/repo/site/components/globals/squircle/index.vue').default})
